export default {"src":"/_next/static/media/org_icon.3a25d2fd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};